<ion-header class="ion-no-border">
  <ion-item lines="full">
    <ion-label>
      <h6 class="bold">Local Recordings</h6>
    </ion-label>

    <ion-button (click)="closeSidebar.emit()" tooltip="Close" aria-label="Close">
      <ion-icon src="/assets/icons/24px/close.svg" slot="icon-only"> </ion-icon>
    </ion-button>
  </ion-item>
</ion-header>

<ion-content>
  <ion-list>
    <ion-item *ngFor="let take of takes; trackBy: trackTakesBy; last as last" [lines]="last ? 'none' : 'inset'" class="take-list-item">
      <ion-label (click)="select(take)" class="ion-text-wrap">
        <p class="action-medium">
          <span *ngIf="take.takeName">{{ take.takeName }}</span>
          <span *ngIf="!take.takeName">Take {{ take.takeNumber }}</span>
        </p>
        <p class="micro-regular">
          {{ take.recordings?.length }} Recording<span *ngIf="take.recordings?.length > 1">s</span>
          <span class="dot">•</span>
          {{ take.date | timeAgo }}
        </p>
      </ion-label>

      <ion-button (click)="editInDescript(take)" class="descript edit-in-descript-button" aria-label="Edit in Descript">
        <span>
          Edit in Descript
        </span>
      </ion-button>

      <ion-button (click)="select(take)" class="arrow" aria-label="Select Take">
        <ion-icon src="/assets/icons/24px/chevron-right.svg" slot="icon-only"></ion-icon>
      </ion-button>
    </ion-item>

    <ion-item *ngIf="(previewRecordings$ | async)?.length" class="header">
      <ion-label>Quality Check</ion-label>
    </ion-item>

    <sc-recording-list-item
      *ngFor="let previewRecording of previewRecordings$ | async; trackBy: trackPreviewRecordingsBy; last as last"
      [recordingID]="previewRecording.recordingID"
      [sessionID]="previewRecording.sessionID"
      [last]="last"
      appearance="preview"></sc-recording-list-item>
  </ion-list>

  <div id="cloud-recordings">
    <p class="micro-bold ion-text-center">
      <ion-icon src="/assets/icons/16px/info-outline.svg"></ion-icon>
      Cloud Recordings
    </p>

    <p class="micro-regular ion-text-center">
      Cloud Recordings are available after your Recording Session has completed. Click the Leave Session button to
      access them.
    </p>
  </div>
</ion-content>
